import { LogLevel, LogService, postLogs } from "@/services/logging";
import { dexieDB } from "@/services/dexie-database";
import LogsModule from "@/store/modules/logs";

const syncFailureMessage = "Logs: Error when trying to sync logs from DexieDB";

// Set once a sync failure is queued in DexieDB, so an outage adds a single
// entry instead of one per sync attempt
let isSyncFailureQueued = false;

/**
 * Synchronize logs from DexieDB to Smeetz logging service.
 * This function is called periodically by the app.
 * It fetches logs from DexieDB, posts them to Smeetz logging service,
 * and then removes them from DexieDB.
 */
export async function syncLogs() {
  if (LogsModule.isSyncInProgress) {
    // avoid initiating another sync while another is still in progress
    return;
  }
  LogsModule.setIsSyncInProgress(true);
  try {
    // 50 rows per 5s pass: the queue also carries the @smeetz/* package
    // lines, which outpace the app's own logging on a busy till — a smaller
    // batch lets the table grow for the whole shift and delays error delivery.
    const logs = await dexieDB.logs.orderBy("_id").limit(50).toArray();
    if (logs.length) {
      await postLogs(logs);
      const ids = logs.map((l) => l._id);
      await dexieDB.logs.where("_id").anyOf(ids).delete();
    }
    isSyncFailureQueued = false;
  } catch (error) {
    try {
      await LogService.infoDirect(syncFailureMessage, error, LogLevel.Error);
    } catch {
      // The logging server is unreachable: queue the report so the next
      // successful sync delivers it
      if (!isSyncFailureQueued) {
        await LogService.info(syncFailureMessage, error, LogLevel.Error);
        isSyncFailureQueued = true;
      }
    }
  } finally {
    LogsModule.setIsSyncInProgress(false);
  }
}
